import { useTrackPreviewActions } from '../../hooks/bi/useTrackPreviewActions';
import { createHOCWithHookInside } from '../createHOCWithHookInside';

/**
 * @deprecated use "useTrackPreviewActions"
 */
export const withTrackPreviewActions = createHOCWithHookInside('WithTrackPreviewActions', useTrackPreviewActions);
